// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class IdleService {

//   constructor() { }
// }

import { Injectable, NgZone } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private timeoutId: any;
  // private idleTime: number = 10 * 60 * 1000; // 10 minutes in milliseconds
  private idleTime: number = 10 * 1000; // 30 seconds
  private lastActivityTime: number = Date.now();

  constructor(private router: Router, private ngZone: NgZone, private route: ActivatedRoute) {}

  startMonitoring() {
    // let expired = sessionStorage.getItem('sessionExpired')
    // if(expired=='true'){
    //   this.logout()
    //   return;
    // }
    // sessionStorage.setItem('sessionExpired','false')
    this.resetTimer(); // Start the timer when the service is activated

    // Listen for user activity events
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('mousemove', this.resetTimer.bind(this));
      window.addEventListener('keydown', this.resetTimer.bind(this));
      window.addEventListener('click', this.resetTimer.bind(this));
      window.addEventListener('scroll', this.resetTimer.bind(this));
    });
  }

  private resetTimer() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    console.log('new timer')
    this.lastActivityTime = Date.now();
    this.timeoutId = setTimeout(() => this.logout(), this.idleTime);
  }

  private logout() {
    // sessionStorage.setItem('sessionExpired','true')
    console.log('User has been logged out due to inactivity');
    // Perform logout actions (e.g., clear user session, redirect to login page)
    // this.router.navigate(['/login']);
    $('#session-timeout-login').show();
    $('#session-timeout-login').addClass('show')
  }

  ngOnInit() {
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     console.log(this.router.url)
    //     if (this.router.url != 'login') {
    //       this.startMonitoring(); // Start the timer after login or route change
    //     }
    //   }
    // });
  }
}
